import script from "./DrawerFormLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerFormLayout.vue?vue&type=script&setup=true&lang=js"

import "./DrawerFormLayout.vue?vue&type=style&index=0&id=71ad4152&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ad4152"]])

export default __exports__